import React, { FC } from 'react';
import './CircularButton.css';
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface CircularButtonProps {
  iconProp: IconProp
  onClick: (()=>void)
  style?: React.CSSProperties | undefined
  disabled?: boolean;
}

const CircularButton: FC<CircularButtonProps> = ({iconProp, onClick, style, disabled = false}: CircularButtonProps) => (
  <div className={`CircularButton${disabled ? ' disabled' : ''}`} style={style} onClick={onClick}>
    <FontAwesomeIcon icon={iconProp}/>
  </div>
);

export default CircularButton;
